/**
 * useDataCapture Hook
 *
 * React Query hook for fetching a job's data capture information.
 */

import { queryKeys } from '@/lib/query-client';
import { useQuery } from '@tanstack/react-query';
import { getDataCapture } from '../api/dataCaptureApi';

export function useDataCapture(jobId: number) {
  const query = useQuery({
    queryKey: queryKeys.jobs.dataCapture(String(jobId)),
    queryFn: () => getDataCapture(jobId),
    enabled: jobId > 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isPending: query.isPending,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
